import React from 'react'
import HeaderDesktop from '../header/HeaderDesktop'
import { useMediaQuery } from '@mui/material'
import { Box } from '@mui/material'
import BreadCrumbProvider from '../breadcrumb/BreadCrumbContext'
import BreadCrumb from '../breadcrumb/BreadCrumb'
import { Outlet } from 'react-router-dom'
import HeaderMobile from '../header/HeaderMobile'
import useClasses from '@/components/hooks/UseClasses'

const styles = (theme) => ({
  containerDesktop: {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
  },
  outletDesktop: {
    height: '100%',
    padding: '2rem',
    overflowY: 'auto',
  },
  containerMobile: {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
  },
  outletMobile: {
    height: '100%',
    padding: '1rem',
    overflowY: 'auto',
  },
})

const HeaderSelector = ({ standard = true }) => {
  const isMobile = useMediaQuery('(max-width:1024px)')
  const classes = useClasses(styles)

  return (
    <Box className={isMobile ? classes.containerMobile : classes.containerDesktop}>
      {isMobile ? <HeaderMobile standard={standard} /> : <HeaderDesktop standard={standard} />}

      <Box className={isMobile ? classes.outletMobile : classes.outletDesktop}>
        <BreadCrumbProvider>
          <BreadCrumb isDesktop={!isMobile} />
          <Outlet />
        </BreadCrumbProvider>
      </Box>
    </Box>
  )
}

export default HeaderSelector
